import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1RepositoryRepositoryFileShareList: build.query<
      ApiAdminV1RepositoryRepositoryFileShareListApiResponse,
      ApiAdminV1RepositoryRepositoryFileShareListApiArg
    >({
      query: () => ({ url: `/api/admin/v1/repository/repository-file-share/` }),
    }),
    apiAdminV1RepositoryRepositoryFileShareCreate: build.mutation<
      ApiAdminV1RepositoryRepositoryFileShareCreateApiResponse,
      ApiAdminV1RepositoryRepositoryFileShareCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-file-share/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiAdminV1RepositoryRepositoryFileShareRetrieve: build.query<
      ApiAdminV1RepositoryRepositoryFileShareRetrieveApiResponse,
      ApiAdminV1RepositoryRepositoryFileShareRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-file-share/${queryArg.id}/`,
      }),
    }),
    apiAdminV1RepositoryRepositoryFileShareListByOrganizationRetrieve:
      build.query<
        ApiAdminV1RepositoryRepositoryFileShareListByOrganizationRetrieveApiResponse,
        ApiAdminV1RepositoryRepositoryFileShareListByOrganizationRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/v1/repository/repository-file-share/list-by-organization/`,
          params: {
            employee_id: queryArg.employeeId,
            organization_id: queryArg.organizationId,
          },
        }),
      }),
    apiAdminV1RepositoryRepositoryFileShareRetrieveByTokenRetrieve: build.query<
      ApiAdminV1RepositoryRepositoryFileShareRetrieveByTokenRetrieveApiResponse,
      ApiAdminV1RepositoryRepositoryFileShareRetrieveByTokenRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-file-share/retrieve-by-token/`,
        params: {
          token: queryArg.token,
        },
      }),
    }),
    apiAdminV1RepositoryRepositoryFileShareShareableEmployeesRetrieve:
      build.query<
        ApiAdminV1RepositoryRepositoryFileShareShareableEmployeesRetrieveApiResponse,
        ApiAdminV1RepositoryRepositoryFileShareShareableEmployeesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/v1/repository/repository-file-share/shareable-employees/`,
          params: {
            distribution_method: queryArg.distributionMethod,
            organization_id: queryArg.organizationId,
            trigger_type: queryArg.triggerType,
          },
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiAdminV1RepositoryRepositoryFileShareListApiResponse =
  /** status 200  */ RepositoryFileShareRead[];
export type ApiAdminV1RepositoryRepositoryFileShareListApiArg = void;
export type ApiAdminV1RepositoryRepositoryFileShareCreateApiResponse =
  /** status 201  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFileShareCreateApiArg = {
  body: {
    /** The file ID */
    file_id?: number;
    /** The organization ID */
    organization_id: number;
    /** The type of trigger for sharing */
    trigger_type: number;
    /** Content sharing method */
    distribution_method: number;
    /** List of employee IDs to share with */
    employee_ids: number[];
    /** Optional personal note to include in the share email */
    note?: string;
  };
};
export type ApiAdminV1RepositoryRepositoryFileShareRetrieveApiResponse =
  /** status 200  */ RepositoryFileShareRead;
export type ApiAdminV1RepositoryRepositoryFileShareRetrieveApiArg = {
  /** A unique integer value identifying this repository file share link. */
  id: number;
};
export type ApiAdminV1RepositoryRepositoryFileShareListByOrganizationRetrieveApiResponse =
  /** status 200  */ RepositoryFileShareRead;
export type ApiAdminV1RepositoryRepositoryFileShareListByOrganizationRetrieveApiArg =
  {
    /** Optional employee ID to filter by */
    employeeId?: number;
    /** The organization ID to filter by */
    organizationId: number;
  };
export type ApiAdminV1RepositoryRepositoryFileShareRetrieveByTokenRetrieveApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFileShareRetrieveByTokenRetrieveApiArg =
  {
    /** The access token provided in the share link */
    token: string;
  };
export type ApiAdminV1RepositoryRepositoryFileShareShareableEmployeesRetrieveApiResponse =
  /** status 200  */ ShareableEmployee;
export type ApiAdminV1RepositoryRepositoryFileShareShareableEmployeesRetrieveApiArg =
  {
    /** Method used for content distribution */
    distributionMethod: number;
    /** The organization id */
    organizationId: number;
    /** The type of trigger for content sharing */
    triggerType: number;
  };
export type RepositoryFileShare = {
  expires_at: string;
  access_count?: number;
};
export type RepositoryFileShareRead = {
  employee_id: number | null;
  employee_email: string;
  employee_first_name: string;
  employee_last_name: string;
  filename: string;
  created_at: string;
  expires_at: string;
  access_count?: number;
  token: string | null;
};
export type TypeEnum = 0 | 1 | 2;
export type RepositoryFile = {
  name: string;
  object_key: string;
  type?: TypeEnum;
  size?: number;
  description?: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  reference?: string | null;
  audience?: any;
};
export type Repository = {
  name: string;
  url: string;
};
export type RepositoryRead = {
  id: number;
  name: string;
  url: string;
};
export type ProcessingStatusEnum = 0 | 1 | 2 | 3;
export type TranscriptionStatusEnum = 0 | 1 | 2 | 3;
export type RepositoryFileRead = {
  id: number;
  name: string;
  object_key: string;
  repository_id: number;
  repository: RepositoryRead;
  type?: TypeEnum;
  size?: number;
  created_at: string;
  updated_at: string;
  share_count: string;
  share_viewed_count: string;
  upvote_count: string;
  downvote_count: string;
  your_vote: string;
  your_feedback_notes: string;
  description?: string | null;
  ai_overview: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  reference?: string | null;
  audience?: any;
  processing_status: ProcessingStatusEnum;
  processing_error: string | null;
  transcription_status: TranscriptionStatusEnum;
  transcription_error: string | null;
  transcription_completed_at: string | null;
  retry_count: number;
};
export type ShareableEmployee = {
  id: number;
  name: string;
};
export const {
  useApiAdminV1RepositoryRepositoryFileShareListQuery,
  useApiAdminV1RepositoryRepositoryFileShareCreateMutation,
  useApiAdminV1RepositoryRepositoryFileShareRetrieveQuery,
  useApiAdminV1RepositoryRepositoryFileShareListByOrganizationRetrieveQuery,
  useApiAdminV1RepositoryRepositoryFileShareRetrieveByTokenRetrieveQuery,
  useApiAdminV1RepositoryRepositoryFileShareShareableEmployeesRetrieveQuery,
} = injectedRtkApi;
